import { defaultTiers } from "@/components/pricing-tiers";
import { isLivePlan, type PlanSubscription, type PurchaseRoute } from "@/lib/billing/purchase-route";
import { GOLD_MONTHLY_PRICE_ID, SILVER_MONTHLY_PRICE_ID } from "@/lib/billing/tier-price-ids";

const FIX_BILLING_NOTE = "Update your payment method before you upgrade to Diamond.";

function monthlyBundlePrice(id: "silver" | "gold" | "diamond"): number | undefined {
  return defaultTiers.find(
    (tier) => tier.id === id && tier.kind === "bundle" && tier.billingPeriod === "monthly" && tier.enabled,
  )?.price;
}

export function diamondMonthlyGap(from: "silver" | "gold"): string | null {
  const current = monthlyBundlePrice(from);
  const diamond = monthlyBundlePrice("diamond");
  if (current === undefined || diamond === undefined || diamond <= current) return null;
  const gap = Math.round((diamond - current) * 100) / 100;
  return Number.isInteger(gap) ? `$${gap}` : `$${gap.toFixed(2)}`;
}

function monthlyPriceGap(plans: readonly PlanSubscription[]): string | null {
  const holds = (priceId: string) => plans.some((sub) => sub.priceId === priceId && isLivePlan(sub));
  const from = holds(GOLD_MONTHLY_PRICE_ID) ? "gold" : holds(SILVER_MONTHLY_PRICE_ID) ? "silver" : null;
  const gap = from === null ? null : diamondMonthlyGap(from);
  return gap === null ? null : `${gap} a month more than ${from === "gold" ? "Gold" : "Silver"}.`;
}

export function diamondUpgradeNote(route: PurchaseRoute, plans: readonly PlanSubscription[]): string | null {
  switch (route.kind) {
    case "fix_billing":
      return FIX_BILLING_NOTE;
    case "plan_change":
      return route.targetInterval === "month" ? monthlyPriceGap(plans) : null;
    case "checkout":
    case "included":
      return null;
  }
}
